<template>
  <div class="axj-competition-club">
    <axj-competition-header
      @create="handleCreateCompetition"
    />
    <axj-competition-main
      :data="tableData"
      @update="handleUpdateCompetition"
      @delete="handleDeleteCompetition"
    />
    <competition-footer
      :page-data="page"
      @page-change="handlePaginationChange"
    />
    <competition-club-edit
      :show.sync="competition.show"
      :is-create="competition.isCreate"
      :competitionId="competition.competitionId"
      @updated="handleCompetitionUpdated"
      @created="handleCompetitionCreated"
    />
  </div>
</template>

<script>
import AxjCompetitionHeader from "./component/axj-competition-header/index";
import AxjCompetitionMain from "./component/axj-competition-main/index";
import CompetitionClubEdit from "./action/competition-club-edit";
import CompetitionFooter from "./component/axj-competition-footer/index";

export default {
  name: "axj-competition-club",
  components: {CompetitionFooter, CompetitionClubEdit, AxjCompetitionMain, AxjCompetitionHeader},
  data(){
    return{
      tableData:[],
      page: {
        page: 1,
        limit: 5,
        desc: true,
        preload: true,
        pageTotal: 0
      },
      competition:{
        show:false,
        isCreate:true,
        competitionId:undefined
      }
    }
  },
  methods:{
    initData(){
      let user=this.$store.getters.getUser
      this.$api.axjExtracurricularApi.competitionClub.listCompetitionClub({
        ...this.page,
        where:JSON.stringify({
          user_id:user.infoUserUid
        }),
      }).then(res=>{
        this.page.pageTotal=res.data.total
        this.tableData=res.data.lists
      },error => {
        console.log(error)
      })
    },
    handleCreateCompetition(){
      this.competition.isCreate=true
      this.competition.show=true
    },
    handleCompetitionCreated(){
      this.initData()
      this.competition.show=false
    },
    handleCompetitionUpdated(){
      this.initData();
      this.competition.show=false
    },
    handleDeleteCompetition(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.deleteCompetition(id)
        this.initData()
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    deleteCompetition(id){
      return new Promise((resolve, reject)=>{
        this.$api.axjExtracurricularApi.competitionClub.deleteCompetitionClub(id).then(res=>{
          console.log('delete')
          resolve()
        },error => {
        })
      })
    },
    handleUpdateCompetition(id){
      this.competition.isCreate=false
      this.competition.show=true
      this.competition.competitionId=id
    },
    handlePaginationChange (val) {
      this.page = val
      this.initData()
    }
  },
  created() {
    this.initData();

    let that=this
    window.handleNext=function (){
      if(that.page.page*that.page.limit<that.page.pageTotal){
        that.page.page=that.page.page+1
        that.handlePaginationChange(that.page)
      }
    }
    window.handlePre=function (){
      if(that.page.page>1){
        that.page.page=that.page.page-1
        that.handlePaginationChange(that.page)
      }
    }
  }
}
</script>

<style slot-scope lang="scss">
.axj-competition-club{
  .el-table__body{
      tr:hover{
        .axj-show-club-main-announce-list{
          .el-collapse-item__header{
            background-color: #F2F5F8;
          }
          .el-collapse-item__content{
            background-color: #F2F5F8;
          }
        }

      }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj-extracurricular/axj-competition-club/index.vue